<template>
  <footer class="relative">
    <app-footer-city :configuration="configuration"/>
    <app-footer-brand/>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex'
import appFooterCity from './app-footer-city'
import appFooterBrand from './app-footer-brand'

export default {
  name: 'app-footer',
  components: {
    appFooterCity,
    appFooterBrand
  },
  computed: {
    ...mapGetters(['configuration'])
  }
}
</script>

<style scoped>
footer {
  margin-top: 3rem;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  color: rgba(255, 255, 255, 0.8);
  background-color: #777777;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/app-footer.vue